import { render, staticRenderFns } from "./HealthProdTypes.vue?vue&type=template&id=ebbe40ae&scoped=true&"
import script from "./HealthProdTypes.vue?vue&type=script&lang=js&"
export * from "./HealthProdTypes.vue?vue&type=script&lang=js&"
import style0 from "./HealthProdTypes.vue?vue&type=style&index=0&id=ebbe40ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbe40ae",
  null
  
)

export default component.exports